import React, {useState} from "react";
import {Dialog} from "@material-ui/core";
import {Form, Formik} from "formik";
import {Button} from "../../Button";
import {strings} from "../../../strings/strings";


export const ContactPhoneDialog = ({open, onPhoneSubmit}) => {
    const [process, setProcess] = useState(false);

    return (
        <Dialog open={open} disableBackdropClick={true}>
            <div className={"dialog"}>
                <Formik initialValues={{
                    phone: ''
                }} onSubmit={values => {
                    setProcess(true);
                    onPhoneSubmit(values);
                }}>
                    {formProps => (
                        <Form>
                            <div className={"dialog__content"}>
                                <span className={"dialog__title"}>{strings.important}</span>

                                <p className={"dialog__message"}>
                                    {strings.contactPhoneDlg}
                                </p>

                                {/* <InputTextMaskOld name={'phone'}
                                               label={strings.personalInfoLivingPhone}
                                               mask={"+38(999)999-99-99"}/> */}

                                <Button label={strings.send}
                                        isProcess={process}
                                        onClickListener={formProps.handleSubmit}/>

                                <Button label={strings.understand} variant={"link"}
                                        onClickListener={() =>
                                            window.location.replace(strings.refs.avtocivilka)
                                        }/>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Dialog>
    )

}
